import { Component } from '@angular/core';
import { BaseGridComponent } from '@base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';

@Component({
    providers: ServiceBagServices,
    selector: 'app-historyview-grid',
    templateUrl: './historyview-grid.component.html',
    styleUrls: ['./historyview-grid.component.scss']
})
export class HistoryViewGridComponent extends BaseGridComponent<BaseEntity, BaseState>
{
    constructor(A: ServiceBagService) {
        super(A, 'HistoryViewGridComponent', BaseEntity, BaseState);
    }

}
